module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "header bg-blue-grey"
  }, [_vm._m(0), _vm._v(" "), _c('UserActions'), _vm._v(" "), _c('h2', {
    staticClass: "color-light-green"
  }, [_vm._v(_vm._s(_vm.app.title) + " "), _c('span', {
    staticClass: "version"
  }, [_vm._v("v" + _vm._s(_vm.app.version))])])]), _vm._v(" "), _c('AppMenu'), _vm._v(" "), _c('Err'), _vm._v(" "), _c('div', {
    staticClass: "app-body"
  }, [(_vm.loading) ? _c('loading-bar') : _vm._e(), _vm._v(" "), _c('router-view')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('span', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/schoox_logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e9dac00e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 421
// module chunks = 2